import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Logo from '../Logo/Logo'
import InternalServerErrorIllustration from '../../Assets/Illustrations/InternalServerErrorIllustration'
import useWindowSize from '../../hooks/useWindowSize'
import { useStyles } from './InternalServerErrorStyles'

function InternalServerError({ reason }) {
  const windowSize = useWindowSize()
  const classes = useStyles()

  useEffect(() => {
    window?.gtag('event', 'quiz_load_failed', {
      event_category: 'Internal server error',
      event_label: 'Internal server error',
    })
  }, [])

  return (
    <Grid
      container
      direction="column"
      className={classes.root}
      style={{ height: `${windowSize?.height}px` }}
    >
      <Helmet>
        <title>Internal server error</title>
      </Helmet>
      <Grid container alignItems="center" className={classes.header}>
        <Logo />
      </Grid>
      <Grid container alignItems="center" className={classes.body}>
        <Grid
          container
          direction="column"
          justify="center"
          alignItems="center"
          className={classes.illustrationAndTextWrapper}
        >
          <Grid item className={classes.illustrationWrapper}>
            <InternalServerErrorIllustration />
          </Grid>
          <Grid item className={classes.textWrapper}>
            <Typography className={classes.text}>{reason}</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default InternalServerError
